<div class="modal modal-rename-account">
  <div class="modal__content">
    <h1 class="modal__title" translate="account-popup.title-rename"></h1>
    <form (ngSubmit)="formSubmit()" [formGroup]="form" novalidate>
      <div class="form-group">
        <div class="form-field form-field--border-radius">
          @if ({ focus: false, control: form.get('name'), field: 'name' }; as ctx) {
            <app-form-field [isControlTouched]="ctx.control.touched"
              [errors]="ctx.control.errors"
              [errorTexts]="fieldErrors(ctx.field)"
              [submitErrors]="submitErrors.asObservable()">
              <div class="modal__row modal__row--small-text">
                <label for="name" [class.fade-in]="ctx.control.value || ctx.focus" translate="account-popup.field.name"></label>
                <span class="modal-rename-account__symbols" translate="account-popup.label.symbols-left" [translateParams]="{count: maxLength - ctx.control.value.length}"></span>
              </div>
              <input data-qa="common.dashboard.rename-text-input"
                type="text" class="form-control"
                id="name" formControlName="name"
                autocomplete="name" [maxLength]="maxLength"
                (focus)="ctx.focus = true"
                (blur)="ctx.focus = false"
                [placeholder]="ctx.focus ? '' : 'account-popup.field.name-placeholder' | translate"/>
            </app-form-field>
          }
        </div>
      </div>
      <div class="actions-wrapper actions-wrapper--popup">
        <button (click)="formSubmit()" type="submit" data-qa="common.dashboard.rename-confirm-button" class="button" translate="account-popup.button.confirm"></button>
        <button type="button" class="link button--link" [mat-dialog-close]="" translate="account-popup.button.cancel"></button>
      </div>
    </form>
  </div>
</div>
